export const contactOption = [
	{
		label: "ID",
		key: "id",
		format: "string",
		dataPosition: "center",
		width: 1,
	},
	{
		label: "Plataforma",
		key: "contact.channel",
		format: "string",
		dataPosition: "left",
		width: 1,
		canFilter: true,
		canSort: true,
		canPrint: true,
		canExcel: true,
		sortKey: null,
	},
	{
		label: "Nombre",
		key: "name",
		format: "string",
		width: 1,
		canFilter: true,
		canSort: true,
		canPrint: true,
		canExcel: true,
		sortKey: null,
	},
	{
		label: "Teléfono",
		key: "phone",
		format: "phone",
		dataPosition: "center",
		width: 1,
		canFilter: true,
		canSort: true,
		canPrint: true,
		canExcel: true,
		sortKey: null,
	},
	{
		label: "Correo",
		key: "email",
		format: "string",
		dataPosition: "left",
		headerPosition: "left",
		width: 16,
		canFilter: true,
		canSort: true,
		canPrint: true,
		canExcel: true,
		sortKey: null,
	},
];

export const contactFilterOption = [
	{ key: "name", text: "Nombre", value: "name" },
	{ key: "code", text: "Código", value: "code" },
	{ key: "phone", text: "Teléfono", value: "phone" },
	{ key: "email", text: "Email", value: "email" },
	{ key: "cedula", text: "Cédula", value: "cedula" },
	{ key: "city", text: "Ciudad", value: "city" },
	{ key: "zone", text: "Zona", value: "zone" },
	{ key: "sector", text: "Sector", value: "sector" },
];

export const dropdownOptions = [
	{
		key: "closeTab",
		options: [
			{ key: "new", text: "Nuevo", value: "Nuevo" },
			{ key: "atender", text: "Atender", value: "Atender" },
			{ key: "client", text: "Cliente", value: "Cliente" },
		],
	},
	{
		key: "dateField",
		options: [
			{ key: "createdDate", text: "Fecha Inicio", value: "createdDate" },
			{ key: "closeDate", text: "Fecha Cierre", value: "closeDate" },
		],
	},
	{
		key: "stateValue",
		options: [
			{ key: "a_tiempo", text: "A Tiempo", value: "A Tiempo" },
			{ key: "en_atraso", text: "En Atraso", value: "En Atraso" },
			{ key: "vencido", text: "Vencido", value: "Vencido" },
		],
	},
	{
		key: "orderBy",
		options: [
			{ key: "createdDate", text: "Fecha de Creación", value: "createdDate" },
			{ key: "closeDate", text: "Fecha de Cierre", value: "closeDate" },
			{ key: "closeState", text: "Estado de Cierre", value: "closeState" },
			{ key: "channel.label", text: "Canal", value: "channel.label" },
			{ key: "contact.name", text: "Contacto", value: "contact.name" },
			{ key: "user.fullName", text: "Usuario", value: "user.fullName" },
			{ key: "tab", text: "Tabs", value: "closeTab" },
			{ key: "group.name", text: "Grupo", value: "group.name" },
			{ key: "tags.name", text: "Etiquetas", value: "tags.name" },
			// { key: "timestamp", text: "Timestamp", value: "timestamp" },
			// { key: "id", text: "ID", value: "id" },
		],
	},
	{
		key: "orderDirection",
		options: [
			{ key: "asc", text: "Ascendente", value: "asc" },
			{ key: "desc", text: "Descendente", value: "desc" },
		],
	},
];
